import { createApi } from '@reduxjs/toolkit/query/react';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import {
  CmsDisclosureRequirementItem,
  GetCmsDisclosureRequirementsInput,
} from './cmsDisclosureRequirements.types';

interface CmsDisclosureRequirementsResponse {
  disclosureRequirements?: CmsDisclosureRequirementItem[];
}

const cmsDisclosureRequirementsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms/standards',
  }),
  reducerPath: 'cmsDisclosureRequirements',
  tagTypes: ['CmsDisclosureRequirements'],
  endpoints: (build) => ({
    getDisclosureRequirements: build.query<
      CmsDisclosureRequirementItem[],
      GetCmsDisclosureRequirementsInput
    >({
      query: ({ standardSlug, slugs }) => ({
        url: `/${standardSlug}/disclosure-requirements`,
        method: 'POST',
        data: { slugs },
      }),
      transformResponse: (response: CmsDisclosureRequirementsResponse) =>
        response.disclosureRequirements ?? [],
    }),
  }),
});

export default cmsDisclosureRequirementsApi;
